import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import VideoSection from './components/VideoSection';
import Services from './components/Services';
import Process from './components/Process';
import Portfolio from './components/Portfolio';
import PricingPlans from './components/PricingPlans';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import CeoPartnerBanner from './components/CeoPartnerBanner';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Header />
        <main>
          <Hero />
          <VideoSection />
          <Services />
          <Process />
          <Portfolio />
          <PricingPlans />
          <Testimonials />
          <Contact />
        </main>
        <CeoPartnerBanner />
        <Footer />
      </div>
    </Router>
  );
}

export default App;